import Link from "next/link";
import styled from "styled-components";

export const BotItemWrapper = styled(Link)`
  align-items: center;
  font-size: 14px;
  display: flex;
  width: 100%;
  padding: 8px;
  margin-bottom: 20px;
  line-height: 20px;
  ${({ isLast, itemCount }) =>
    isLast && itemCount % 2 !== 0
      ? `margin-left: 30px;
      @media screen and (max-width: 990px) {
        margin-left: 0px;
      }`
      : "margin-inline: auto;"}
  .arrow-icon {
    margin-left: 10px;
    visibility: hidden;
    transition: visibility 0.2s ease-in-out;
  }
  &:hover {
    .arrow-icon {
      transition: visibility 0.2s ease-in-out;
      visibility: visible;
    }
  }
  @media screen and (min-width: 990px) {
    width: 45%;
  }
`;

export const BotTitle = styled.span`
  color: #101828;
  height: 14px;
  display: flex;
  font-size: 14px;
  font-weight: 600;
`;
export const BotTitleH1 = styled.h1`
  color: #101828;
  display: flex;
  font-size: 24px;
  font-weight: 600;
  @media screen and (max-width: 600px) {
    font-size: 16px;
  }
`;
export const BotListsWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;
export const BotDescription = styled.p`
  color: #667085;
  font-weight: 400;
  font-size: 12px;
  margin-top: 8px;
  text-align: justify;
  padding: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 38px;
`;

export const BotAvatar = styled.div`
  padding: 5px 4px;
  overflow: hidden;
  .profile-image {
    width: 150px;
    height: 150px;
    margin-top: 24px;
  }
  @media screen and (max-width: 600px) {
    .profile-image {
      width: 80px;
      height: 80px;
      margin-top: 16px;
      
    }
  }
`;
